const GLOBAL_REDUCERS = {};

export { GLOBAL_REDUCERS };
